import { Building2 } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";

/**
 * A-Block A0 — branded placeholder for the holding-first pages.
 *
 * A0 ships ONLY routing & shell; the data-bound list (A1) and Client360
 * envelope (A2) replace these bodies. The skeleton proves the route resolves,
 * reads its params, and renders inside the app chrome without 404/crash.
 */
export function ClientShellSkeleton({
  title,
  subtitle,
  note,
}: {
  title: string;
  subtitle?: string;
  note?: string;
}) {
  return (
    <div className="p-6 md:p-8 space-y-6">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-xl bg-primary/10 text-primary flex items-center justify-center shrink-0">
          <Building2 className="w-5 h-5" />
        </div>
        <div className="min-w-0">
          <h1 className="text-xl font-semibold tracking-tight truncate">{title}</h1>
          {subtitle ? (
            <p className="text-sm text-muted-foreground truncate">{subtitle}</p>
          ) : null}
        </div>
      </div>

      <p className="text-sm text-muted-foreground">
        {note ?? "Розділ будується у наступних під-етапах (A1/A2). Маршрут активний."}
      </p>

      <div className="space-y-3 max-w-3xl">
        <Skeleton className="h-9 w-64" />
        <Skeleton className="h-28 w-full" />
        <Skeleton className="h-28 w-full" />
      </div>
    </div>
  );
}
